/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetEvChargingStationPathParameters } from 'api/actions/get-ev-charging-station/get-ev-charging-station-path-parameters';
import { GetEvChargingStationResponse } from 'api/actions/get-ev-charging-station/get-ev-charging-station-response';

type GetEvChargingStationQueryParameters = Record<string, any>;

/**
 * The path of the GetEvChargingStation action.
 */
export const getEvChargingStationActionPath = new SweetPath<keyof GetEvChargingStationPathParameters>(
  '/ev-charging-stations/{evChargingStationId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetEvChargingStation actions.
 */
export default function createGetEvChargingStationAction(axios: AxiosInstance) {
  return function getEvChargingStationAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetEvChargingStationPathParameters;
    query?: GetEvChargingStationQueryParameters;
  }) {
    const path = getEvChargingStationActionPath.insert(parameters);

    return axios.get<GetEvChargingStationResponse, GetEvChargingStationResponse>(path, { params: query, headers });
  };
}
